import c from "./LandingFormPageLayout";

export default c;
